const isProduction = process.env.NODE_ENV === 'production'

export { isProduction }

// 生产走当前域名 + nginx 反代；开发指到本地 Java
export const baseUrl = isProduction ? '' : 'http://localhost:8080'

export const shareUrl = isProduction
  ? 'https://311music.xyz'
  : (typeof window !== 'undefined' ? window.location.origin : 'http://localhost:8081')
